module.exports = __webpack_public_path__ + "img/yes.64854a60.jpg";